import { PropsWithChildren } from 'react';

import { Link as RRLink } from 'react-router-dom';

import { isAbsolute } from '../../services/url';

type TLink = PropsWithChildren<{
  to: string;
  className?: string;
  'data-testid'?: string;
}>;

export default function Link({
  to,
  className,
  children,
  'data-testid': dataTestId,
  ...props
}: TLink) {
  return isAbsolute(to) ? (
    <a
      href={to}
      rel="noreferrer"
      className={className}
      data-testid={dataTestId}
      {...props}
    >
      {children}
    </a>
  ) : (
    <RRLink to={to} className={className} data-testid={dataTestId} {...props}>
      {children}
    </RRLink>
  );
}
